/// <reference path="../types/config.d.ts" />

export enum EarnType {
	sushiSwap = 'sushiSwap',
	uniSwap = 'uniSwap',
	pancakeSwap = 'pancakeSwap',
}

export enum DepositType {
	Deposit = 0,
	CreateLock,
	IncreaseLockAmount,
	IncreaseUnlockTime,
}

export const MOBILE_WIDTH_BREAKPOINT = 767

export const TABLED_WIDTH_BREAKPOINT = 970

export const LP_TOKEN_DECIMALS = 18

export const ADDITIONAL_WEEK = 1

export const MAX_VESIS_WEEKS = 208

export const WEEKS_IN_YEAR = 52

export const WEEKS_IN_MOUTH = 4

export const SECONDS_IN_WEEK = 60 * 60 * 24 * 7
